import { createApp } from '@app/adapters/create-app'

import ExportFileInstanceModalContent from './../sections/export-file-instance-modal-content.vue'
import humps from 'humps'

onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour~='export-file-instance-modal-content']")
    .each(function () {
      const {
        exportFileName,
        exportFileInstanceId,
        exportFileInstanceChannel,
        exportFileInstanceLastId,
        workflowProgressChannel,
        workflowProgressLastId,
        ledgerId,
        workflowId,
        unbalancedLedgerTooltip,
        sumOfAllAccounts,
        balancedLedger,
        firmOrSilverfinAdmin,
      } = humps.camelizeKeys(JSON.parse(this.dataset.jsonPayload))

      const renderedHTML = this.innerHTML

      createApp(ExportFileInstanceModalContent, {
        renderedHTML,
        exportFileInstanceId,
        exportFileName,
        exportFileInstanceChannel,
        exportFileInstanceLastId,
        workflowProgressChannel,
        workflowProgressLastId,
        ledgerId,
        workflowId,
        unbalancedLedgerTooltip,
        sumOfAllAccounts,
        balancedLedger,
        firmOrSilverfinAdmin,
      }).mount(this)
    })
})
